var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    {
      ref: "dialog",
      staticClass: "media-share-dialog",
      attrs: { title: _vm.title, closable: "" },
    },
    [
      _c("h6", { staticClass: "ui-subheading" }, [_vm._v("Link lifetime")]),
      _vm._v(" "),
      _c(
        "ui-radio-group",
        {
          staticClass:
            "lifetime-radio-button-group ui-layout ui-alignment-center-space-between",
          model: {
            value: _vm.lifetime,
            callback: function ($$v) {
              _vm.lifetime = $$v
            },
            expression: "lifetime",
          },
        },
        [
          _c("ui-radio", {
            attrs: {
              label: _vm._f("date")(_vm.customLabel, "yyyy-MM-dd"),
              value: "0",
            },
            on: { change: _vm.showDatepicker },
          }),
          _vm._v(" "),
          _c("ui-radio", { attrs: { label: "24 hours", value: "86400" } }),
          _vm._v(" "),
          _c("ui-radio", { attrs: { label: "One week", value: "604800" } }),
          _vm._v(" "),
          _c("ui-radio", { attrs: { label: "4 weeks", value: "2419200" } }),
          _vm._v(" "),
          _c("ui-radio", { attrs: { label: "Forever", value: "-1" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ui-datepicker", {
        ref: "datepicker",
        staticClass: "ui-datepicker__right ui-datepicker__hidden",
        attrs: {
          "disabled-dates": _vm.isDateBeforeNow,
          "close-on-select": "",
          label: "Link expires date",
        },
        model: {
          value: _vm.selectedDate,
          callback: function ($$v) {
            _vm.selectedDate = $$v
          },
          expression: "selectedDate",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ui-layout ui-gutter ui-alignment-center-space-between",
        },
        [
          _c(
            "div",
            { staticClass: "ui-layout-item ui-input--link-password" },
            [
              _c("ui-input", {
                attrs: {
                  autocomplete: "new-password",
                  label: "Link password (optional)",
                  type: "password",
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "ui-layout-item ui-size-50 ui-checkbox--downloadable",
            },
            [
              _c("ui-checkbox", {
                attrs: {
                  label: "Enable easy download via button",
                  tooltip: "Check to show download button on player",
                },
                model: {
                  value: _vm.isDownloadable,
                  callback: function ($$v) {
                    _vm.isDownloadable = $$v
                  },
                  expression: "isDownloadable",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("h6", { staticClass: "ui-subheading" }, [_vm._v("Share by")]),
      _vm._v(" "),
      _c(
        "ui-tabs",
        [
          _c(
            "ui-tab",
            { staticClass: "ui-tab__reset-padding", attrs: { label: "Link" } },
            [
              _c("share-link", {
                attrs: {
                  downloadable: _vm.isDownloadable,
                  expires: _vm.expires,
                  lifetime: parseInt(_vm.lifetime),
                  "media-id": _vm.mediaId,
                  password: _vm.password,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ui-tab",
            {
              staticClass: "ui-tab__reset-padding",
              attrs: { label: "E-mail" },
            },
            [
              _c("share-email", {
                attrs: {
                  downloadable: _vm.isDownloadable,
                  expires: _vm.expires,
                  lifetime: parseInt(_vm.lifetime),
                  "media-id": _vm.mediaId,
                  password: _vm.password,
                },
                on: {
                  send: function ($event) {
                    return _vm.$refs.dialog.close()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }